import request from '@/utils/request'
import useUserStore from '@/store/modules/user.js'

// 查询我的分组列表(限制只能请求自己创建的数据)
export function pageMyGroupsApi(query) {
  const _query=query
  _query.createBy=useUserStore().userInfo.userName
  return request({
    url: '/flowable/group/list',
    method: 'get',
    params: _query
  })
}

// 查询我的分组详细
export function getMyGroupsByIdApi(id) {
  return request({
    url: '/flowable/group/' + id,
    method: 'get'
  })
}

// 新增我的分组
export function addMyGroupsApi(data) {
  return request({
    url: '/flowable/group',
    method: 'post',
    data: data
  })
}

// 修改我的分组
export function updateMyGroupsApi(data) {
  return request({
    url: '/flowable/group',
    method: 'put',
    data: data
  })
}

// 删除我的分组
export function delMyGroupsApi(ids) {
  return request({
    url: '/flowable/group/' + ids,
    method: 'delete'
  })
}
